export class Step4 {

    public getpersonnemorale = 'form.mapa_at.getpersonnemorale';
    public getspan7 = 'form.mapa_at.getspan7';
    public getcivilite = 'form.mapa_at.getcivilite';
    public getnom = 'form.mapa_at.getnom';
    public getpren = 'form.mapa_at.getpren';
    public getfonc = 'form.mapa_at.getfonc';
    public getspan8 = 'form.mapa_at.getspan8';
    public getnum = 'form.mapa_at.getnum';
    public gettypevoie = 'form.mapa_at.gettypevoie';
    public getnomvoie = 'form.mapa_at.getnomvoie';
    public getcp = 'form.mapa_at.getcp';
    public getville = 'form.mapa_at.getville';
    public getpays = 'form.mapa_at.getpays';
    public gettel = 'form.mapa_at.gettel';
    public getposte = 'form.mapa_at.getposte';
    public getfax = 'form.mapa_at.getfax';
    public getmel = 'form.mapa_at.getmel';
    public getspan9 = 'form.mapa_at.getspan9';
    public getmontantindefini = 'form.mapa_at.getmontantindefini';
    public getvaleur = 'form.mapa_at.getvaleur';
    public getmontantminiannuel = 'form.mapa_at.getmontantminiannuel';
    public getmontantmaxiannuel = 'form.mapa_at.getmontantmaxiannuel';
    public gettrancheconditionnelle = 'form.mapa_at.gettrancheconditionnelle';
    public gettrancheferme = 'form.mapa_at.gettrancheferme';
    public getoffrebasse = 'form.mapa_at.getoffrebasse';
    public getoffreelevee = 'form.mapa_at.getoffreelevee';
    public getspan10 = 'form.mapa_at.getspan10';
    public getspan11 = 'form.mapa_at.getspan11';
    public getsoustraitancenon = 'form.mapa_at.getsoustraitancenon';
    public getvaleursoustraitance = 'form.mapa_at.getvaleursoustraitance';
    public getpartpct = 'form.mapa_at.getpartpct';
    public getpartinconnue = 'form.mapa_at.getpartinconnue';
    public getspan12 = 'form.mapa_at.getspan12';
    public getattribue = 'form.mapa_at.getattribue';
    public getnumlot = 'form.mapa_at.getnumlot';
    public getdescription = 'form.mapa_at.getdescription';
    public geturl = 'form.mapa_at.geturl';
    public getspan13 = 'form.mapa_at.getspan13';
    public getdevise = 'form.mapa_at.getdevise';
    public getspan17 = 'form.mapa_at.getspan17';
    public getspan18 = 'form.mapa_at.getspan18';
    public getintitule = "form.mapa_at.getintitule";
}
